import React from 'react';
import TraffixLoadingScreen from './TraffixLoadingScreen';
import styles from './Common.module.css';

/**
 * Screensaver component using the premium Traffix Engine animation.
 * Automatically appears after 30 seconds of inactivity.
 * @param {Object} props
 * @param {string} props.className - Additional CSS class
 */
const ScreensaverOverlay = ({
  className = "",
  onClick
}) => {
  return (
    <div className={`${styles.loadingOverlay} ${styles.fullScreen} ${className}`} onClick={onClick}>
      <TraffixLoadingScreen />
    </div>
  );
};

export default ScreensaverOverlay;
